import { useContext } from 'react';

import { CategoricalBarChartRawDataContext } from '../contexts/CategoricalBarChartRawData.context.js';

export const useCategoricalBarChartRawData = () =>
  useContext(CategoricalBarChartRawDataContext);
